import axios, { AxiosResponse, AxiosError } from "axios";
import {  toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const storedUserDetails = localStorage.getItem("userdetails");
const token = storedUserDetails ? JSON.parse(storedUserDetails).token.replace(/^"(.*)"$/, '$1') : null;

export const getVehicle = (
  per_page_records:any,
  page_number:any,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
  active:any,
  number_plate?:any,
  warehouse_name?:any,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios
      .get(`${global.api_url}/api/vehicles`, {
        params :{ per_page_records, page_number,active,number_plate, warehouse_name}, 
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 201){
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        }
        else if( error.response?.status === 404)
        {
          _errorCallBack(error.response.data);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else{
          toast.error("Server Error");
        }
      });
  };
  export const getWarehouses = (
      _successCallBack: (response: any) => void,
      _errorCallBack: (errMessage: any) => void,
    ) => {
      const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
      const headers = {
        Authorization: `Bearer ${userDetailsFromStorage.token}`
      };
      axios
        .get(`${global.api_url}/api/warehouses`, {
          headers: headers,
        })
        .then((response: AxiosResponse) => {
          if (response.status === 200) {
            _successCallBack(response.data);
          }
        })
        .catch((error: AxiosError) => {
          console.log('Error caught:', error);
          if (error.response?.status === 400) {
            _errorCallBack(error.response.data);
          }
          else if  (error.response?.status === 401){
            localStorage.clear();
          }
          else{
            toast.error("Server Error");
          }
        });
    };
      export const getPincode = (pincode: string, _successCallback: (response: any) => void, _errorCallback: (errMessage: string) => void) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
        axios.get(`${global.pincode_url}/api/postalcodes/${pincode}`, {
      headers: {
        'Authorization': `${userDetailsFromStorage.token}`,
      }
    })
      .then((response: AxiosResponse) => {
        _successCallback(response.data);
      })
      .catch((error: AxiosError) => {
        if (error.response?.status == 401) {
          toast.error("Login Expired")
        }
        else {
          _errorCallback((error.response?.data?.message ? error.response?.data?.message + ': ' : "") + error.message || 'Something went wrong, please try again.');
        }
      });
  };
export const getOrders = (
  per_page_records: number,
  page_number: number,
  status: string,
  source: string,
  time_period: any,
  order_id: any,
  customer_name: string,
  customer_phone: any,
  customer_state: string,
  vehicles_id: any,
  warehouses_ids: number[] | null,
  _successCallback: (response: any) => void,
  _errorCallback: (errMessage: string) => void
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  axios
    .get(`${global.api_url}/api/orders`,  {
      headers: { Authorization: `Bearer ${userDetailsFromStorage.token}` },
      params: {
        per_page_records,
        page_number,
        status,
        source,
        time_period,
        order_id,
        customer_name,
        customer_phone,
        customer_state,
        vehicles_id,
        warehouses_ids
      }
    })
    .then((response: AxiosResponse) => {
      _successCallback(response.data);
    })
    .catch((error: AxiosError) => {
      if (error.response?.status === 401) {
        toast.error("Login Expired");
      } else {
        _errorCallback(
          error.message +
            (error.response?.statusText ? ": " + error.response?.statusText : "") ||
            "Something went wrong, please try again."
        );
      }
    });
};

export const addSingleOrder = (
    item_name: string,
    item_description: string,
    cod: string,
    to_name: string,
    to_company: string,
    to_street_lines: string,
    to_country: string,
    to_pin: string,
    to_phone: string,
    to_email: string,
    order_id: string,
    quantity: string,
    quantity_unit: string,
    type:string,
    weight: string,
    weight_unit: string,
    price: string,
    made_in: string,
    currency: string,
    cgst_amount: number,
    igst_amount: number,
    sgst_amount: number,
    discount_amount: number,
    hsn_code: string,
    additional_items: string,
    sku_id: string,
    logistics_cost: string,
    lat: string,
    long:string,
    length: string,
    breadth: string,
    height: string,
    to_city: string,
    to_state: string,
    order_creation_date: string,
    amount:string,
     customerId?: string,
    force_new_customer?: number,
    _successCallback: (response: any) => void,
    _errorCallback: (errMessage: string) => void
)=> {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    var FormData = require('form-data');
    var data = new FormData();
    data.append('item_name', item_name);
    data.append('item_description', item_description);
    data.append('cod', cod);
    data.append('to_name', to_name);
    data.append('to_company', to_company);
    data.append('to_street_lines', to_street_lines);
    data.append('to_country', to_country);
    data.append('to_pin', to_pin);
    data.append('to_phone', to_phone);
    data.append('to_email', to_email);
    data.append('order_id', order_id);
    data.append('quantity', quantity.toString());
    data.append('quantity_unit', quantity_unit);
    data.append('type', type);
    data.append('weight', weight.toString());
    data.append('weight_unit', weight_unit);
    data.append('price', price.toString());
    data.append('made_in', made_in);
    data.append('currency', currency);
    data.append('igst_amount', igst_amount.toString());
    data.append('cgst_amount', cgst_amount.toString());
    data.append('sgst_amount', sgst_amount.toString());
    data.append('hsn_code', hsn_code.toString());
    data.append('discount_amount', discount_amount.toString());
    data.append('additional_items', additional_items);
    data.append('sku_id', sku_id);
    data.append('logistics_cost', logistics_cost.toString());
    data.append('latitude', lat);
    data.append('longitude', long);
    data.append('length', length.toString());
    data.append('breadth', breadth.toString());
    data.append('height', height.toString());
    data.append('to_state', to_state);
    data.append('to_city', to_city);
    data.append('order_creation_date',order_creation_date);
    data.append('amount',amount);
    data.append('customers_id',customerId);
    data.append('force_new_customer',force_new_customer);
    axios
      .post(`${global.api_url}/api/orders`, data, {
        headers: {
            Authorization: `Bearer ${userDetailsFromStorage.token}`
        },
      })
      .then((response: AxiosResponse) => {
        _successCallback(response.data);
      })
      .catch((error: AxiosError) => {
        if (error.response?.status == 401) {
               toast.error("Login Expired")
            }
        else if (error.response?.status == 400){
         _errorCallback(error.response.data)
        }
      });
  };
export const assignVehicle = (
    orderId: string,
    warehouseId: number,
    vehicleId: number,
    _successCallback: (response: any) => void,
    _errorCallback: (error: any) => void
) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const requestBody = {
        warehouses_id: warehouseId,
        vehicles_id: vehicleId
    };

    fetch(`${global.api_url}/api/assign_vehicle/${orderId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${userDetailsFromStorage.token}`
        },
        body: JSON.stringify(requestBody)
    })
     .then((response: AxiosResponse) => {
        _successCallback(response.data);
      })
      .catch((error: AxiosError) => {
        if (error.response?.status == 401) {
               toast.error("Login Expired")
            }
        else if (error.response?.status == 400){
         _errorCallback(error.response.data)
        }
      });
  };
  export const reassignVehicle = (
    orderId: string,
    warehouseId: number,
    vehicleId: number,
    tripId:string,
    _successCallback: (response: any) => void,
    _errorCallback: (error: any) => void
) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const requestBody = {
        warehouses_id: warehouseId,
        vehicles_id: vehicleId,
        trip_id:tripId
    };

    fetch(`${global.api_url}/api/reassign_vehicle/${orderId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${userDetailsFromStorage.token}`
        },
        body: JSON.stringify(requestBody)
    })
     .then((response: AxiosResponse) => {
        _successCallback(response.data);
      })
      .catch((error: AxiosError) => {
        if (error.response?.status == 401) {
               toast.error("Login Expired")
            }
        else if (error.response?.status == 400){
         _errorCallback(error.response.data)
        }
      });
  };
export const editTripRemarks = (
      trip_id:any,
      odometer_start:string,
      odometer_end:string,
      orders_picked:string,
      orders_delivered:string,
      orders_delivered_inc:1,
      remarks:string,
    _successCallback: (response: any) => void,
    _errorCallback: (error: any) => void
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
      const payload = {
        odometer_start,
        odometer_end,
        orders_delivered,
       orders_picked,
        orders_delivered_inc,
         remarks,
    };
  axios.put(`${global.api_url}/api/edit_trips/${trip_id}`, payload, {
    headers: {
      'Authorization': `Bearer ${userDetailsFromStorage.token}`,
    },
  })
     .then((response: AxiosResponse) => {
        _successCallback(response.data);
      })
      .catch((error: AxiosError) => {
        if (error.response?.status == 401) {
               toast.error("Login Expired")
            }
        else if (error.response?.status == 400){
         _errorCallback(error.response.data)
        }
      });
  };

export const editOrders = (
    order_id:any,
  warehouses_id: number,
  vehicles_id:any,
  status: string,
  amount_upi:any,
  amount_cash:any,
  remarks:any,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void
) => {
  const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
  const payload = { warehouses_id,vehicles_id,status,amount_upi,amount_cash,remarks};
  axios.put(`${global.api_url}/api/orders/${order_id}`, payload, {
    headers: {
      'Authorization': `Bearer ${userDetailsFromStorage.token}`,
    },
  })
    .then((response: AxiosResponse) => {
      _successCallBack(response.data);
    })
    .catch((error: AxiosError) => {
      console.log('Error caught:', error);
      if (error.response?.status === 400) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 401) {
        localStorage.clear();
      } else {
        toast.error("Server Error");
      }
    });
};
  export const getItems = (per_page_records: number, page_number: number,order_id:any, _successCallback: (response: any) => void, _errorCallback: (errMessage: string) => void) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    axios.get(`${global.api_url}/api/list_items?orders_id=${order_id}&per_page_records=${per_page_records}&page_number=${page_number}`, {
        headers: {
              Authorization: `Bearer ${userDetailsFromStorage.token}`
        }
    })
        .then((response: AxiosResponse) => {
            _successCallback(response.data);
        })
        .catch((error: AxiosError) => {
            if (error.response?.status == 401) {
               toast.error("Login Expired")
            }
            else
                _errorCallback(error.message + (error.response?.statusText ? ': ' + error.response?.statusText : "") || 'Something went wrong, please try again.');
        });
}
export const editItems = (
  id: number,
  status: string,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => voida
) => {
  const payload = { id, status };
const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
axios.put(
  `${global.api_url}/api/edit_items`,payload,
  {
    headers: {
      'Authorization': `Bearer ${userDetailsFromStorage.token}`,
    },
  }
)
    .then((response: AxiosResponse) => {
      _successCallBack(response.data);
    })
    .catch((error: AxiosError) => {
      console.log('Error caught:', error);
      if (error.response?.status === 400) {
        _errorCallBack(error.response.data);
      } else if (error.response?.status === 401) {
        localStorage.clear();
      } else {
        console.log(error);
        toast.error("Server Error");
      }
    });
};
export const getCustomerDetails = (
  phone_number:any,
  _successCallBack: (response: any) => void,
  _errorCallBack: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios
      .get(`${global.api_url}/api/customers?phone=${phone_number}`, {
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
        else if (response.status === 201){
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        }
        else if( error.response?.status === 404)
        {
          _errorCallBack(error.response.data);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else{
          toast.error("Server Error");
        }
      });
  };
  export const getTrips = (
    per_page_records: number,
    page_number: number,
    from_date: string,
    to_date: string,
    _successCallBack: (response: any) => void,
    _errorCallBack: (errMessage: any) => void,
    vehicle_id?: number,
    warehouse_name?:any,
    with_order:number,
    fuel_type?:string
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage.token}`
    };
    axios
      .get(`${global.api_url}/api/get_trips`, {
        params: {
          per_page_records,
          page_number,
          from_date,
          to_date,
          vehicle_id,
          warehouse_name,
          fuel_type,
          with_order:1
        },
        headers: headers,
      })
      .then((response: AxiosResponse) => {
        if (response.status === 200) {
          _successCallBack(response.data);
        }
      })
      .catch((error: AxiosError) => {
        console.log('Error caught:', error);
        if (error.response?.status === 400) {
          _errorCallBack(error.response.data);
        }
        else if  (error.response?.status === 401){
          localStorage.clear();
        }
        else{
         _errorCallBack(error.response?.data);
        }
      });
  };
  export const getWarehouseCompanyMapping = (
   companies_id:any,
    _successCallBack?: (response: any) => void,
    _errorCallBack?: (errMessage: any) => void,
  ) => {
    const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");
    const headers = {
      Authorization: `Bearer ${userDetailsFromStorage?.token}`,
    };
    axios
      .get(`${global.api_url}/api/warehouses_companies?companies_id=${companies_id}`, { headers })
      .then((response: AxiosResponse) => {
        if (response.status === 200 || response.status === 201) {
          _successCallBack?.(response.data);
        } else {
          _errorCallBack?.(`Unexpected status code: ${response.status}`);
        }
      })
      .catch((error: AxiosError<any>) => {
        console.log("Error caught:", error);
  
        if (error.response) {
          const { status, data } = error.response;
  
          if (status === 400 || status === 404) {
            _errorCallBack?.(data);
          } else if (status === 401) {
            localStorage.clear();
          } else {
            _errorCallBack?.(`Error ${status}: ${data?.message || "Unknown error"}`);
          }
        } else {
          _errorCallBack?.("Network or server error");
        }
      });
  };